import React from 'react';
import './PrivacyPolicy.css';

function PrivacyPolicy() {
  return (
    <div className="privacy-container">
      <div className="privacy-content">
        <h1>Privacy Policy</h1>
        
        <section>
          <h2>Anonymitet og Datasikkerhet</h2>
          <p>
            Pure Paths er dedikert til å beskytte ditt personvern og sikre at all kommunikasjon 
            forblir anonym. Vi har implementert følgende sikkerhetstiltak:
          </p>
          <ul>
            <li>
              <strong>Invitasjonskode-system:</strong> Vi bruker et unikt invitasjonskode-system 
              i stedet for personlig identifiserbar informasjon. Dette sikrer at brukere kan 
              kommunisere fritt uten å avsløre sin identitet.
            </li>
            <li>
              <strong>Anonym Chat:</strong> Alle samtaler med vår AI-assistent er helt anonyme. 
              Vi lagrer ingen personlig identifiserbar informasjon sammen med chat-loggene.
            </li>
            <li>
              <strong>Sikker Datalagring:</strong> All data lagres sikkert i kryptert format, 
              og er kun tilgjengelig for autoriserte administratorer på et aggregert nivå.
            </li>
          </ul>
        </section>

        <section>
          <h2>Datainnsamling og Bruk</h2>
          <p>
            Vi samler kun inn følgende anonyme data:
          </p>
          <ul>
            <li>Chat-innhold for å forbedre AI-responser</li>
            <li>Aggregert bruksstatistikk for å forbedre tjenesten</li>
            <li>Anonyme tilbakemeldinger og forbedringsforslag</li>
          </ul>
        </section>

        <section>
          <h2>Dine Rettigheter</h2>
          <p>
            Som bruker har du rett til å:
          </p>
          <ul>
            <li>Forbli anonym i all kommunikasjon</li>
            <li>Få innsikt i hvordan dine anonyme data brukes</li>
            <li>Be om sletting av dine chat-logger</li>
          </ul>
        </section>

        <section>
          <h2>Kontakt Oss</h2>
          <p>
            Hvis du har spørsmål om våre personvernrutiner, vennligst kontakt oss via 
            kontaktskjemaet på nettsiden vår.
          </p>
        </section>
      </div>
    </div>
  );
}

export default PrivacyPolicy; 